import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { apiGetUsers } from '../../api/userApi';
export var useProjectUsers = function useProjectUsers() {
  var _useState = useState([]),
      userList = _useState[0],
      setUserList = _useState[1];
  /**
   * methods
   */


  var requestProjectUserList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var params, _yield$apiGetUsers, _yield$apiGetUsers2, res, list;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                limit: 10000
              };

              if (data !== null && data !== void 0 && data.organizationSlug) {
                params.organization_slug = data.organizationSlug;
              }

              if (data !== null && data !== void 0 && data.organizationId) {
                params.organization_id = data.organizationId;
              }

              _context.next = 5;
              return apiGetUsers(params);

            case 5:
              _yield$apiGetUsers = _context.sent;
              _yield$apiGetUsers2 = _slicedToArray(_yield$apiGetUsers, 1);
              res = _yield$apiGetUsers2[0];
              list = ((res === null || res === void 0 ? void 0 : res.data) || []).map(function (item) {
                var _item$user, _item$user2;

                return {
                  value: item.user.id,
                  label: "".concat((_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.first_name, " ").concat((_item$user2 = item.user) === null || _item$user2 === void 0 ? void 0 : _item$user2.last_name)
                };
              });
              list.push({
                value: null,
                label: 'Unassigned'
              });
              setUserList(list);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestProjectUserList(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    requestProjectUserList: requestProjectUserList,
    userList: userList
  };
};